import { styled } from "@mui/system"
import MuiButton, { ButtonProps } from "@mui/material/Button"

interface CustomButtonProps extends ButtonProps {
  stylevariant?: string
  startIcon?: React.ReactNode
  overrideColor?: string
  overrideColorSecondary?: string
  label?: string
}

export const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    !["overrideColor", "overrideColorSecondary", "fullWidth"].includes(
      prop as string,
    ),
})<CustomButtonProps>(
  ({ variant, startIcon, overrideColor, overrideColorSecondary, label }) => ({
    height: "40px",
    borderRadius: "100px",
    // border: "1px solid var(--white)",
    border: "1px solid var(" + overrideColor + ")",
    textTransform: "none",
    // color: "var(--navy)",
    color: "var(" + overrideColorSecondary + ")",
    padding: "10px 24px",
    "&:hover": {
      backgroundColor: 'transparent',
      color: "var(--blue-blue-09)"
    },
    "&:focus": {
      backgroundColor: 'transparent',
    },
    ...(variant === "outlined" && {
      // color: "var(--white)",
      color: "var(" + overrideColor + ")",
      "&:hover": {
        borderColor: "var(" + overrideColor + ")",
      },
    }),
    ...(variant === "contained" && {
      color: "var(" + overrideColor + ")",
      backgroundColor: "var(" + overrideColorSecondary + ")",
      "&:hover": {
        backgroundColor: "var(" + overrideColorSecondary + ")",
        color: "var(" + overrideColor + ")",
      },
    }),
    ...(startIcon && {
      padding: "10px 16px 10px 12px",
    }),
    ...(!label && { "& .MuiButton-startIcon": { margin: 0 } }),
  }),
)
